import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/Index.scss';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import ReactGA from 'react-ga';
const root = ReactDOM.createRoot(document.getElementById('root'));
// ReactGA.initialize('UA-251611486-1');
ReactGA.initialize('UA-252768063-1');
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
